
export enum DoorPlanProfileTypeCd {
	CURRENT = 'Current',
	DEFAULT = 'Default',
	STATIC = 'Static'}

